import React from 'react';
import { useTranslation } from 'react-i18next';

import { Container } from '@uncinc/uncinc-react-kitchen-sink';

import Page from '../../containers/Page';
import useClasses from '../../hooks/useClasses';
import BuddyInviteRefuseForm from './Form';

import './style.scss';
import { Main } from '../../components';

const PageBuddyInviteRefuse = () => {
  const { t } = useTranslation();
  const { buildClass } = useClasses('PageBuddyInviteRefuse');

  const translationBase = 'pages.buddy_invite_refuse';

  return (
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    <Page className={buildClass()} title={t(`${translationBase}.title`)} showFooter>
      <Main>
        <Container>
          <div className="row">
            <div className="col-md-10 col-lg-8 offset-md-1 offset-lg-2 py-8 py-lg-12">
              <div className={buildClass('title')}>
                <h1>{t(`${translationBase}.title`)}</h1>
              </div>

              <div className={buildClass('body')}>
                <p>{t(`${translationBase}.body`)}</p>
              </div>

              <BuddyInviteRefuseForm />
            </div>
          </div>
        </Container>
      </Main>
    </Page>
  );
};

export default PageBuddyInviteRefuse;
